import actions from './actions/actions'
import mutations from './mutations/mutation'
const state = {
	//测试
    //https: 'http://',
    //线上
    https: 'https://',
    PictureSuffix: '图片后缀',
	//测试
    //prefixAgreement: 'http',
    //线上 
    prefixAgreement: 'https',
    show: false,
    getPubconfiginfo: '',
    logoimgurl: '',
    allreqdomain: '',
    cmpycode: '',
    index_swiperBanner: [],
    promotionList: '',
    browseinfoList: [],
    GoodsListForRecommend: '',
    numhahaha: 0,
    common_cityCodes: '',
    selectAddress: [{
            ShortName: '北京',
            code: '123213',
            show: true
        },
        {
            ShortName: '请选择',
            code: '',
            show: false
        },
        {
            ShortName: '请选择',
            code: '',
            show: false
        }
    ],
    selProvinces: [],
    selCity: [],
    selArea: []
}

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/store/modules/common/common.js